<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Error Log</h1>
                    <!--<a (click)="openModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Create Announcement</span></i>
                    </a>-->
                </div>

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loading">

                    <div class="card shadow noActionButtons">

                        <div class="container-fluid">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="true"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="gridOptions"
                                                 [rowData]="data"
                                                 [columnDefs]="dataHeaders"
                                                 [enableSorting]="true"
                                                 [enableColResize]="true"
                                                 (rowClicked)="onRowClicked($event)"
                                                 (gridReady)="onGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                                </ag-grid-angular>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
